import React from 'react'

// import Fade from 'react-reveal/Fade'
// import ImageHero from 'assets/images/img-hero.jpg'
// import ImageHero_ from 'assets/images/img-hero-frame.jpg'
// import IconCities from 'assets/images/icons/ic_cities.svg'
// import IconTraveler from 'assets/images/icons/ic_traveler.svg'
// import IconTreasure from 'assets/images/icons/ic_treasure.svg'
// import formatNumber from 'utils/formatNumber'

import imageUrl from 'assets/images/imageGH.png'
import Button from 'elements/Button'

export default function Hero(props) {

    function showHighlight() {
        window.scrollTo({
            top: props.refHighlight.current.offsetTop - 100,
            behavior: "smooth"
        });
    }

    return (

        <div>

            <section class="bg-dark text-white text-center d-flex align-items-center justify-content-center"
                style={{ height: '85vh', background: `url(${imageUrl}) no-repeat center center / cover`, borderRadius: '15px', margin: '80px 20px 0', }}>
                <div>
                    <h1 class="display-4 fw-bold">Pesona Tak Terlupakan</h1>
                    <p class="lead">Nikmati Keindahan Pemandangan Bukit dan Pengalaman Tak Terlupakan.</p>
                    <Button className="btn px-5" style={{ backgroundColor: "#388E3C", borderColor: "#388E3C", color: "#fff", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
                        onClick={showHighlight}>
                        Explore More
                    </Button>
                </div>
            </section>

            {/* <section className='container pt-5'>
                <div className="row align-items-center">
                    <Fade>
                        <div className="col-auto pr-5" style={{ width: 530 }}>
                            <h1 className="fw-bold line-height-1 mb-3">
                                Forget Busy Work, <br /> Start Next Vacation
                            </h1>
                            <p className="mb-4 fw-light text-gray-500 w-75">
                                We provide what you need to enjoy your holiday with family. Time to make another memorable moments.
                            </p>
                            <Button className="btn px-5" hasShadow isPrimary onClick={showHighlight}>
                                Show Me Now
                            </Button>

                            <div className="row" style={{ marginTop: 80 }}>
                                <div className="col-auto" style={{ marginRight: 35 }}>
                                    <img width="36" height="36" src={IconTraveler} alt={`${props.data.travelers} Travelers`} />
                                    <h6 className="mt-3">
                                        {formatNumber(props.data.travelers)}{" "} <span className="text-gray-500 font-weight-light">
                                            travelers
                                        </span>
                                    </h6>
                                </div>
                                <div className="col-auto" style={{ marginRight: 35 }}>
                                    <img width="36" height="36" src={IconTreasure} alt={`${props.data.treasures} Treasures`} />
                                    <h6 className="mt-3">
                                        {formatNumber(props.data.treasures)}{" "} <span className="text-gray-500 font-weight-light">
                                            treasures
                                        </span>
                                    </h6>
                                </div>
                                <div className="col-auto">
                                    <img width="36" height="36" src={IconCities} alt={`${props.data.cities} Cities`} />
                                    <h6 className="mt-3">
                                        {formatNumber(props.data.cities)}{" "} <span className="text-gray-500 font-weight-light">
                                            cities
                                        </span>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </Fade>
                    <Fade right>
                        <div className="col-6 pl-5">
                            <div class="position-relative" style={{ width: 520, height: 410 }}>
                                <img src={ImageHero} className="img-fluid position-absolute" alt="Room with couches" style={{ margin: "-30px 0 0 -30px", zIndex: 1 }}></img>
                                <img src={ImageHero_} className="img-fluid position-absolute" alt="Room with couches frame" style={{ margin: "0 -15px -15px 0" }}></img>
                            </div>
                        </div>
                    </Fade>
                </div>

            </section> */}

        </div>

    )
}
